<template>
  <div class="c-breadcrumb">
    <ul class="c-breadcrumb__list">
      <li class="c-breadcrumb__item" v-for="link in links" :key='link.id'>
        <router-link class="c-breadcrumb__link" :to="`/content${link.page_url}`">
          <span>{{link.title}}</span>
        </router-link>

        <icon class="c-breadcrumb__arrow" name="arrow" width="10" height="10"></icon>
      </li>
      <li class="c-breadcrumb__item is-current">
        <span>{{currentPage.title}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'page-breadcrumb',

  props: {
    links: [Array,Object],
    currentPage: Object,
  },
};
</script>

<style lang="scss">
.c-breadcrumb {
  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    padding: 0.25em 0;
    margin: 0;
    display: inline-block;
    color: $colour-nhs-dark-grey;
    font-size: 14px;
  }

  &__item:not(:first-of-type) {
    margin-left: 0.5em;
  }

  &__link {
    text-decoration: none;
    color: $colour-nhs-blue;
  }

  &__arrow {
    margin-left: 0.5em;
  }
}
</style>
